import auth from './auth/auth.json';
import personalArea from './personalArea/personalArea.json';
import other from './other/other.json';
import roaming from './roaming/roaming.json';
import phoneFilter from './phoneFilter/phoneFilter.json';
import unpaidAmoutAndUsedbytes from './unpaidAmoutAndUsedbytes/unpaidAmoutAndUsedbytes.json';
import bookingMsisdn from './bookingMsisdn/bookingMsisdn.json';
import callerIdentify from './callerIdentify/callerIdentify.json';
import storeInfo from './storeInfo/storeInfo.json';
import storeReserve from './storeReserve/storeReserve.json';
import autoPay from './autoPay/autoPay.json';
import paymentTool from './paymentTool/paymentTool.json';
import international from './international/international.json';
import happyGo from './happyGo/happyGo.json';
import payment from './payment/payment.json';
import electronicInvoice from './electronicInvoice/electronicInvoice.json';
import cfgMsg from './cfgMsg/cfgMsg.json';
import autoRechargeInit from './autoRechargeInit/autoRechargeInit.json';
import usedbytesSearchController from './usedbytesSearchController/usedbytesSearchController.json';
import initUsedBytesInfo from './initUsedBytesInfo/initUsedBytesInfo.json';
import queryRateChangeList from './queryRateChangeList/queryRateChangeList.json';
import AuthorizeController from './AuthorizeController/AuthorizeController.json';
import paymentController from './paymentController/paymentController.json';
import contractController from './contractController/contractController.json';
import rateController from './rateController/rateController.json';
import functionDataController from './functionDataController/functionDataController.json';
import safetyAuthorize from './safetyAuthorize/safetyAuthorize.json';
import prepaidRechargeController from './prepaidRechargeController/prepaidRechargeController.json';
import recordController from './recordController/recordController.json';
import FcoinController from './FcoinController/FcoinController.json';
import parkingfeeController from './parkingfeeController/parkingfeeController.json';
import personalAreaLayout from './personalAreaLayout/personalAreaLayout.json';
import fetnetPortal from './fetnetPortal/fetnetPortal.json';
import surfProtector from './surfProtector/surfProtector.json';
import fiveGsaController from './5gsaController/5gsaController.json';

export default {
  ...auth,
  ...personalArea,
  ...other,
  ...roaming,
  ...phoneFilter,
  ...unpaidAmoutAndUsedbytes,
  ...bookingMsisdn,
  ...callerIdentify,
  ...storeInfo,
  ...storeReserve,
  ...autoPay,
  ...paymentTool,
  ...international,
  ...happyGo,
  ...payment,
  ...electronicInvoice,
  ...cfgMsg,
  ...autoRechargeInit,
  ...usedbytesSearchController,
  ...initUsedBytesInfo,
  ...queryRateChangeList,
  ...AuthorizeController,
  ...paymentController,
  ...contractController,
  ...rateController,
  ...functionDataController,
  ...safetyAuthorize,
  ...prepaidRechargeController,
  ...recordController,
  ...FcoinController,
  ...parkingfeeController,
  ...personalAreaLayout,
  ...fetnetPortal,
  ...surfProtector,
  ...fiveGsaController,
};
